// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"60957":"3fd1914691fd0114","74724":"b6323009d4472833","95868":"6438dbb375600f1b","96325":"36c3a1fa84dd3aac"}[chunkId] + ".css";
};